<template>
  <div style="display: inline-block">
    <el-dialog :visible.sync="visible"
            title="客户开票信息"
            width="60%"
               max-height="300px"
               >
      <div class="el-dialog-div">
        <el-row style="margin-bottom: 30px" >
          <el-col :span="22">
            <span class="receipt-detail">客户名称：{{name}}</span>
          </el-col>
          <el-col :span="22">
            <span class="receipt-detail">客户编号：{{number}}</span>
          </el-col>
        </el-row>
        <el-form v-for="(detailItem, itemIndex) of form"
                 :key="itemIndex"
                 ref="form"
                 :model="detailItem"
                 size="medium"
                 label-width="120px">
          <div class="re-el-form__flex">
            <div class="medium" style="position: relative">
                <el-form-item label="公司名称" prop="company_name" class="form-item">
                   <el-tooltip class="item" effect="dark" :content="detailItem.company_name" placement="top">
                   <span>{{detailItem.company_name}}</span>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="开户行及账号" prop="bank_info" class="form-item">
                  <span>{{detailItem.bank_info}}</span>
                </el-form-item>
                <el-form-item label="地址及电话" prop="address_phone" class="form-item">
                  <span>{{detailItem.address_phone}}</span>
                </el-form-item>
                <el-form-item label="税号" prop="tax_number" class="form-item">
                  <span>{{detailItem.tax_number}}</span>
                </el-form-item>
                <el-form-item label="" v-if="detailItem.attached_file.length">
                  <template>
                    <div class="view-navbar">
                      <ul class="clear-both">
                        <li v-for="(item, index) in detailItem.attached_file" :key="index">
                          <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                            <img v-if="item.type === 'pic'" style="width: 100px; height: 100px" :src="item.tmp_url" @click="onViewImage">
                            <i v-if="item.type === 'pdf' || item.type === 'eml'"
                               class="sj-icon-pdf"
                               style=" font-size:100px; margin-top: 50px"
                               @click="onGetPdfFile(item, index)"></i>
                          </el-tooltip>
                        </li>
                      </ul>
                    </div>
                  </template>
                </el-form-item>
                <hr v-if="itemIndex < form.length - 1" style="border: 1px dashed; color: #999; margin-bottom: 20px">
            </div>
          </div>
        </el-form>
        <div>
          <hr style="border: 1px dashed; color: #999; margin-bottom: 20px">
          <p>注：如需新增或修改开票信息，请发邮件给财务开票的同事。</p>
          <p>邮件内容请注明：</p>
          <p>1、新增开票信息或修改开票信息；</p>
          <p>2、客户名称，客户ID；（如：“客户名称：零启营销，客户ID：353”）；</p>
          <p>3、客户最新的开票信息：公司名称、开户行及账号、地址及电话、税号；</p>
          <p>4、客户提供的开票信息的证明文件。</p>
          <div class="flex-ai-start">
            <span style="margin-right: 6px">示例</span>
            <el-image
              style="width: 100px; height: 100px"
              :src="expImgUrl"
              :preview-src-list="[expImgUrl]"></el-image>
          </div>
        </div>
        <div class="flex-jc-end">
          <el-button type="primary"
                     @click="visible = false">关闭
          </el-button>
        </div>
      </div>
    </el-dialog>

  </div>

</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'

export default {
  mixins: [],
  components: {},
  data () {
    return {
      visible: false,
      fileList: [],
      customerid: null,
      name: null,
      number: null,
      form: [],
      load: false,
      expImgUrl: '/static/img/customer-receipt.png',
    }
  },
  methods: {
    openDialog (customer) {
      // 清空并设置所需字段
      this.customerid = customer.customerid
      this.name = customer.name
      this.number = customer.number
      let id = this.customerid
      this.form = []

      // 获取该客户下所有发票信息
      request.page('getCustomerReceiptInfo', {customerid: id}).then(({data}) => {
        this.visible = true
        for (let i = 0; i < data.length; i++) {
          this.form.push(data[i])
          this.form[i].attached_file = this.form[i].attached_file.filter(item => item)
        }
      })
    },
    onGetPdfFile (item) {
      this.$confirm('确认下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': getToken()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '下载已取消',
        })
      })
    },
    onViewImage (event) {
      if (event.target.src) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
  }
}
</script>

<style scoped>
.receipt-detail {
  font-size: 20px;
  margin-left: 50px;
}
.medium {
  width: 700px;
}

.form-item {
  width: 580px;
}

.el-dialog-div {
  overflow: auto;
}

.receipt-button {
  margin: 0 0 10px 0;
}

.view-navbar {
  right: 0px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;
}
ul {
  transform: translateX(0px);
  transition: all 0.3s;
  box-sizing: content-box;
  overflow: hidden;
  padding: 1px 0;
}
li {
  float: left;
  list-style: none;
  width: 100px;
  height: 100px;
  margin-right: 5px;
  cursor: pointer;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  transition: opacity 0.15s;
}

.flex-jc-end {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.flex-ai-start {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/customer/components/CustomerReceiptForm.vue